import { createSlice } from '@reduxjs/toolkit'

export const selectedAccountSlice = createSlice({
    name: 'selectedAccount',
    initialState: {},
    reducers: {
        setSelectedAccount: (state, action) => {
            return action.payload
        }
    }
})

export const { setSelectedAccount } = selectedAccountSlice.actions

export const getSelectedAccount = (state) => state?.selectedAccount

export default selectedAccountSlice.reducer